/* ========================================
   prodnamo - fond ASCII "veines"
   Matrice de caracteres mono, plein ecran, 60 fps.
   Bruit deforme (domain warping) en cretes -> filaments organiques
   qui se deforment lentement. Leger halo autour de la souris.

   Rendu : atlas de glyphes pre-dessines + un drawImage par cellule
   (aucun fillText par frame). Pause quand l'onglet est cache.
   ======================================== */
(function () {
  'use strict';

  var canvas = document.getElementById('siteBg');
  if (!canvas || !canvas.getContext) return;

  /* ---------- reglages ---------- */
  var TOUCH = window.matchMedia('(pointer: coarse)').matches;
  var COLS = 90;                     // nb de colonnes vise sur ordi (le cout CPU en depend, pas la taille d'ecran)
  var CELL;                          // taille d'une cellule (px), calculee dans resize()
  var SPEED = 1;                     // vitesse globale (1 = lent, 2 = 2x plus rapide)
  var SCALE = 0.045;                 // finesse du motif (plus petit = motifs plus larges)
  var MAX_ALPHA = 0.8;               // luminosite max des glyphes
  var MOUSE_R = 15;                  // rayon du halo souris (en cellules)
  var GLYPHS = ['·', ':', '+', '×', '#', '@'];
  var LEVELS = 8;
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var ctx = canvas.getContext('2d', { alpha: true });
  var atlas = document.createElement('canvas');
  var actx = atlas.getContext('2d');
  var W, H, dpr, cols, rows, bright, glyph, fontReady = false;

  function buildAtlas() {
    var s = CELL * dpr;
    atlas.width = s * GLYPHS.length;
    atlas.height = s * LEVELS;
    actx.clearRect(0, 0, atlas.width, atlas.height);
    actx.font = Math.round(CELL * 0.69 * dpr) + 'px ' + (fontReady ? '"Geist Mono", ' : '') + 'ui-monospace, monospace';
    actx.textAlign = 'center';
    actx.textBaseline = 'middle';
    for (var l = 0; l < LEVELS; l++) {
      actx.fillStyle = 'rgba(255,255,255,' + (0.05 + l * 0.08).toFixed(2) + ')';
      for (var k = 0; k < GLYPHS.length; k++) {
        actx.fillText(GLYPHS[k], k * s + s / 2, l * s + s / 2 + dpr);
      }
    }
  }

  function resize() {
    dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    W = window.innerWidth;
    H = window.innerHeight;
    CELL = TOUCH ? 20 : Math.max(16, Math.round(W / COLS));
    canvas.width = W * dpr;
    canvas.height = H * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    cols = Math.ceil(W / CELL) + 1;
    rows = Math.ceil(H / CELL) + 1;
    bright = new Float32Array(cols * rows);
    glyph = new Uint8Array(cols * rows);
    buildAtlas();
  }

  /* ---------- bruit de valeur 2D (lattice 64, tuilable) ----------
     Graine FIXE : le motif est identique sur toutes les pages. */
  var N = 64, lat = new Float32Array(N * N), seed = 0x9e3779b9;
  for (var q = 0; q < N * N; q++) {
    seed = (seed + 0x6D2B79F5) | 0;                          // mulberry32
    var z = Math.imul(seed ^ (seed >>> 15), 1 | seed);
    z = (z + Math.imul(z ^ (z >>> 7), 61 | z)) ^ z;
    lat[q] = ((z ^ (z >>> 14)) >>> 0) / 4294967296;
  }

  function noise(x, y) {
    var xi = Math.floor(x), yi = Math.floor(y), tx = x - xi, ty = y - yi;
    tx = tx * tx * (3 - 2 * tx);
    ty = ty * ty * (3 - 2 * ty);
    var i0 = xi & 63, j0 = (yi & 63) * N, i1 = (xi + 1) & 63, j1 = ((yi + 1) & 63) * N;
    var a = lat[i0 + j0], b = lat[i1 + j0], c = lat[i0 + j1], d = lat[i1 + j1];
    return (a + (b - a) * tx) * (1 - ty) + (c + (d - c) * tx) * ty;
  }
  function fbm(x, y) {
    return noise(x, y) * 0.65 + noise(x * 2.1 + 7.3, y * 2.1 + 3.1) * 0.35;
  }

  /* ---------- motif : veines ----------
     Le temps vient de l'horloge (pas du chargement de la page) : en changeant
     de page, l'animation reprend exactement la ou elle en etait. */
  function clock() { return ((Date.now() / 1000) % 86400) * SPEED; }
  function veins() {
    var T = clock();
    var s = SCALE, n = GLYPHS.length;
    for (var j = 0; j < rows; j++) {
      for (var i = 0; i < cols; i++) {
        var w1 = fbm(i * s + T * 0.035, j * s + 3.1);
        var w2 = fbm(i * s + 7.7, j * s - T * 0.028);
        var x = i * s + (w1 - 0.5) * 3.2 + T * 0.01;
        var y = j * s + (w2 - 0.5) * 3.2;
        var r = (1 - Math.abs(2 * noise(x, y) - 1)) * 0.6
              + (1 - Math.abs(2 * noise(x * 2.3 + 5.1, y * 2.3 + 1.7) - 1)) * 0.4;
        r = r * r * r; r = r * r;                       // r^6 : cretes fines
        var b = (r - 0.06) * 1.5;
        if (b <= 0) continue;
        if (b > MAX_ALPHA) b = MAX_ALPHA;
        var idx = i + j * cols;
        bright[idx] = b;
        glyph[idx] = Math.min(n - 1, (b * n) | 0) + 1;
      }
    }
  }

  /* ---------- souris ---------- */
  var mx = -1e4, my = -1e4;
  if (!TOUCH) {
    window.addEventListener('pointermove', function (e) { mx = e.clientX; my = e.clientY; }, { passive: true });
    window.addEventListener('pointerleave', function () { mx = my = -1e4; }, { passive: true });
  }
  function halo() {
    var mi = mx / CELL, mj = my / CELL;
    var j0 = Math.max(0, (mj - MOUSE_R) | 0), j1 = Math.min(rows, (mj + MOUSE_R) | 0);
    var i0 = Math.max(0, (mi - MOUSE_R) | 0), i1 = Math.min(cols, (mi + MOUSE_R) | 0);
    for (var j = j0; j < j1; j++) {
      for (var i = i0; i < i1; i++) {
        var idx = i + j * cols;
        if (!glyph[idx]) continue;
        var dx = i - mi, dy = j - mj, r = Math.sqrt(dx * dx + dy * dy);
        if (r < MOUSE_R) bright[idx] = Math.min(1, bright[idx] + (1 - r / MOUSE_R) * 0.5);
      }
    }
  }

  /* ---------- boucle (plafonnee a 30 fps : le motif est lent, 60 ne se voit pas) ---------- */
  var FRAME_MS = 1000 / 30, last = 0;
  function frame() {
    bright.fill(0);
    glyph.fill(0);
    veins();
    if (!TOUCH) halo();

    ctx.clearRect(0, 0, W, H);
    var s = CELL * dpr;
    for (var j = 0; j < rows; j++) {
      for (var i = 0; i < cols; i++) {
        var idx = i + j * cols, g = glyph[idx];
        if (!g) continue;
        var l = Math.min(LEVELS - 1, (bright[idx] * LEVELS) | 0);
        ctx.drawImage(atlas, (g - 1) * s, l * s, s, s, i * CELL, j * CELL, CELL, CELL);
      }
    }
  }

  var running = false;
  function loop(now) {
    if (!running) return;
    if (now - last >= FRAME_MS - 1) { last = now; frame(); }
    requestAnimationFrame(loop);
  }
  function start() {
    if (running || REDUCED) return;
    running = true;
    requestAnimationFrame(loop);
  }
  function stop() { running = false; }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop(); else start();
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { resize(); if (REDUCED) frame(); }, 120);
  });

  resize();
  if (document.fonts && document.fonts.load) {
    document.fonts.load('11px "Geist Mono"').then(function () { fontReady = true; buildAtlas(); });
  }

  frame();                           // 1re image tout de suite (puis fondu CSS)
  canvas.classList.add('is-ready');
  if (!REDUCED) start();             // reduced-motion : on reste sur l'image fixe
})();
